import createReducer from 'redux/lib/reducerConfig';
import { selectCompanyPlans } from 'redux/mapping/job/selectors';
import { ActionTypes as SharedActionTypes, sharedPages } from 'redux/marketPrice/sharedFilter';
import { reportError } from 'utils/reporting';
import { TagsService, TagType, CompanyJobTagService, PricejobService } from 'types';

export const filterInitialState = {
  plan: null,
  jobSubFamily: [],
  jobLevel: [],
  grade: [],
  mapped: 'all',
  search: [],
  tags: [],
  sort: { companyJobTitle: 'ASC' },
};

const initialState = {
  jobFamilies: [],
  jobLevels: [],
  grades: [],
  paymarkets: [],
  plans: [],
  tags: [],
  filter: filterInitialState,
  createdCompanyJobs: [],
};

const ActionTypes = {
  SET_FILTER: 'MAPPING_JOB_COMPANY/SET_FILTER',
  SET_FILTER_DATA: 'MAPPING_JOB_COMPANY/SET_FILTER_DATA',
  RESET_FILTER: 'MAPPING_JOB_COMPANY/RESET_FILTER',
  SET_COMPANY_JOBS: 'MAPPING_JOB_COMPANY/SET_COMPANY_JOBS',
  SET_COMPANY_PAYMARKETS: 'MAPPING_JOB_COMPANY/SET_COMPANY_PAYMARKETS',
  SET_JOBS_LOADING: 'MAPPING_JOB_COMPANY/SET_JOBS_LOADING',
  SET_CREATED_COMPANY_JOB: 'SET_CREATED_COMPANY_JOB',
};

export const setFilter = (filter) => ({
  type: ActionTypes.SET_FILTER,
  payload: filter,
});

export const setCreatedCompanyJobs = (companyJob) => ({
  type: ActionTypes.SET_CREATED_COMPANY_JOB,
  payload: companyJob,
});

const setFilterData = (filterData) => ({
  type: ActionTypes.SET_FILTER_DATA,
  payload: filterData,
});

export const resetFilter = () => (dispatch, getState) => {
  const plans = selectCompanyPlans(getState());
  const currentPlan = plans.find(plan => plan.current);
  dispatch({
    type: ActionTypes.RESET_FILTER,
    payload: {
      ...filterInitialState,
      plan: currentPlan ? currentPlan.id : null,
    },
  });
};

export const loadCompanyFilters = (plan, jobSubFamily) => async (dispatch) => {
  try {
    const { rows: tags } = await TagsService.getTagList({ type: TagType.COMPANY_JOB, ignorePagination: true });

    const { jobLevels, jobFamilies, grades, plans } = await PricejobService.getFilters({
      plan: [plan],
      ...(jobSubFamily ? { jobSubFamily: jobSubFamily } : {}),
      tagsType: TagType.COMPANY_JOB,
    });
    dispatch(setFilterData({ jobLevels, jobFamilies, grades, plans, tags }));
  } catch (e) {
    reportError(e);
  }
};

export const loadTags = () => async (dispatch) => {
  try {
    const { rows: tags } = await TagsService.getTagList({ type: TagType.COMPANY_JOB, ignorePagination: true });
    dispatch(setFilterData({ tags }));
  } catch (e) {
    reportError(e);
  }
};

export const addCompanyJobTag = ({ companyJobIds, tags, replace }) => async () => {
  try {
    await CompanyJobTagService.assignCompanyJobTags({
      requestBody: {
        companyJobIds,
        tags,
        replace,
      },
    });
  } catch (err) {
    reportError(err);
  }
};

export const companyReducer = createReducer(
  initialState,
  {
    [ActionTypes.SET_FILTER]: (state, { payload }) => {
      return {
        ...state,
        filter: payload,
      };
    },
    [ActionTypes.RESET_FILTER]: (state, action) => {
      return {
        ...state,
        filter: action.payload,
      };
    },
    [ActionTypes.SET_COMPANY_JOBS]: (state, action) => {
      return {
        ...state,
        jobs: action.payload.jobs,
      };
    },
    [ActionTypes.SET_COMPANY_PAYMARKETS]: (state, action) => {
      return {
        ...state,
        paymarkets: action.payload,
      };
    },
    [ActionTypes.SET_FILTER_DATA]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    [ActionTypes.SET_JOBS_LOADING]: (state, action) => {
      return {
        ...state,
        isJobsLoading: action.payload,
      };
    },
    [ActionTypes.SET_CREATED_COMPANY_JOB]: (state, action) => {
      return {
        ...state,
        createdCompanyJobs: action.payload,
      }
    },
    [SharedActionTypes.SET_SHARED_FILTER]: (state, action) => {
      if (action.page !== sharedPages.jobs) {
        const { plan, ...sharedFilter } = action.payload;
        return {
          ...state,
          filter: { ...state.filter, ...sharedFilter, plan: plan[0] },
        };
      }
      return state;
    },
  }
);
